import Axios, { AxiosError } from 'axios';
import eventEmitter from '../utils/eventEmitter';

/**
 * Define a baseURL somente para as requisições de autenticação e endpoints do Connect.
 */
function mountBaseUrlAuth() {
  const env = process.env.NODE_ENV;
  if (env === 'development') {
    return 'http://localhost:8000/api';
  }
  return 'https://connect.publisol.com.br/api';
}

// Helper para saber se uma URL deve ser ignorada no interceptor
function isIgnoredUrl(url?: string): boolean {
  if (!url) return false;
  if (url.includes('/token/refresh/') || url.includes('/auth/logout/')) {
    return true;
  }
  return false;
}

const authApi = Axios.create({
  baseURL: mountBaseUrlAuth(),
  withCredentials: true, // cookies de sessão
});

// Interceptor de resposta para lidar com 401 e tentar refresh
authApi.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config;
    
    // Se for 401, não for /token/refresh e não for /auth/logout
    if (
      error.response?.status === 401 && 
      originalRequest?.url && 
      !isIgnoredUrl(originalRequest.url)
    ) {
      // Evita múltiplas tentativas
      if (!(originalRequest as any)._retry) {
        (originalRequest as any)._retry = true;
        try {
          // Tenta renovar token
          await authApi.post('/token/refresh/');
          // refaz a requisição original
          return authApi(originalRequest);
        } catch (refreshError) {
          eventEmitter.emit('logout');
          return Promise.reject(refreshError);
        }
      } else {
        // Já tentou o refresh antes e falhou
        eventEmitter.emit('logout');
      }
    }

    return Promise.reject(error);
  },
);

export { authApi };
